import * as ActionType from '../../constants/actionType';

export const showLicenseModal = () => ({
  type: ActionType.SHOW_LICENSE_MODAL,
});

export const hideLicenseModal = () => ({
  type: ActionType.HIDE_LICENSE_MODAL,
});

export const setLicense = (data) => ({
  type: ActionType.SET_LICENSE,
  data,
});

export const showLicenseCountdown = () => ({
  type: ActionType.SHOW_LICENSE_COUNTDOWN,
});

export const hideLicenseCountdown = () => ({
  type: ActionType.HIDE_LICENSE_COUNTDOWN,
});

export const setTessaraLicense = (isTessaraInstrument) => ({
  type: ActionType.SET_TESSARA_LICENSE,
  isTessaraInstrument,
});
